import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { IconComponent } from '@shared/icon/icon.component';
import { Router } from 'lingo2-models';

@Component({
  selector: 'app-exercises-filter',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, IconComponent],
  templateUrl: './exercises-filter.component.html',
  styleUrls: ['./exercises-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExercisesFilterComponent implements AfterViewInit {
  cdr = inject(ChangeDetectorRef);

  private scroll;
  @Input() filterList: string[];
  @Input() selectedFilter = '0';
  @Output() selectFilter = new EventEmitter<string>();

  @ViewChild('filter') filter: ElementRef;

  ngAfterViewInit() {
    this.scroll = this.filter.nativeElement.querySelector('.scroll');
  }

  public onSelectFilter(item: string) {
    this.selectFilter.emit(item);
    this.cdr.markForCheck();
  }

  public contentTypeTitle(index: string) {
    return `content-type-title.${Router.getNameByContentType(+index)}`;
  }

  public onLeftScroll() {
    this.scroll.scrollLeft -= 70;
    this.cdr.markForCheck();
  }

  public onRightScroll() {
    this.scroll.scrollLeft += 70;
    this.cdr.markForCheck();
  }

  public hidden(btn: string): boolean {
    if (this.scroll) {
      const scrollLeft = this.scroll.scrollLeft;
      const offsetWidth = this.scroll.offsetWidth;
      const scrollWidth = this.scroll.querySelector('.filter-list').scrollWidth;

      if (btn === 'left') {
        return scrollLeft > 50;
      } else if (btn === 'right') {
        return scrollLeft + offsetWidth < scrollWidth - 50;
      }

      return true;
    }
  }

  public trackByFn(index) {
    return index;
  }
}
